import _             from 'underscore';
import React, { FC } from 'react';
import { List }      from 'semantic-ui-react';

import { DecisionEngineQueries }                                 from '../../../../../queries';
import { CorvalProjectActivity, KeyedObject, SystemEvent, Uuid } from '../../../../../types';
import { ListFromQuery, ListFromQueryItemProps }                 from '../../../../components/from-query/ListFromQuery';
import { TextLink }                                              from '../../../../components/display/TextLink';
import { runIfFunction }                                         from '../../../../../util';
import { FinePrintMessage }                                      from '../../../../components/util/messaging/FinePrintMessage';
import { InlineLoadingIndicatorLabel }                           from '../../../../components/util/loading/InlineLoadingIndicatorLabel';

interface Props {
	id: Uuid,
	categoryId?: Uuid,
	subCategoryId?: Uuid,
	activityCount?: number,
	
	onClick?( item: CorvalProjectActivity ): void,
}

const defaultProps: Props = {
	id:            null,
	onClick:       null,
	categoryId:    null,
	subCategoryId: null,
	activityCount: 7,
}

const ObjectiveDetailRelatedActivityList: FC<Props> = ( props ) => {
	
	let { categoryId, subCategoryId } = props,
	    filterToCategory              = ( categoryId !== null );
	
	return (
		
		<ListFromQuery
			query={ DecisionEngineQueries.queries.GET_SUBOBJECTIVE( `id activities{ activity { id categoryId subCategoryId displayName description } }` ) }
			queryOptions={ {
				variables: {
					id: props.id
				}
			} }
			queryResultObject={ data => {
				
				return _.chain( data.subObjective.activities )
				        .filter( a => ( filterToCategory && categoryId ) ? ( a.activity.categoryId === categoryId ) : true )
				        .filter( a => ( filterToCategory && subCategoryId ) ? ( a.activity.subCategoryId === subCategoryId ) : true )
				        .first( props.activityCount )
				        .sortBy( 'displayName' )
				        .value();
			} }
			containerComponent={ ( p: KeyedObject ) => (
				<List relaxed verticalAlign={ 'top' }>
					{ p.children }
				</List>
			) }
			loadingComponent={ ()=> <InlineLoadingIndicatorLabel label={'Loading activities...'} />}
			itemComponent={ ( itemProps: ListFromQueryItemProps<CorvalProjectActivity> ) => (
				
				<List.Item key={ itemProps.item.id }>
					<List.Icon name={ 'lightning' } color={ 'teal' }/>
					<List.Content>
						<List.Header>
							{ _.isFunction( props.onClick )
							  ? <TextLink onClick={ () => runIfFunction( props.onClick, itemProps.item ) }>{ itemProps.item.activity.displayName }</TextLink>
							  : itemProps.item.activity.displayName
							}
						</List.Header>
						
						<List.Description>
							<FinePrintMessage>{ itemProps.item.activity.description }</FinePrintMessage>
						</List.Description>
					</List.Content>
				</List.Item>
			) }
			noItemsComponent={ () => null }>
		
		</ListFromQuery>
	);
};

ObjectiveDetailRelatedActivityList.defaultProps = defaultProps;

export { ObjectiveDetailRelatedActivityList }
